// AI features are a paid add-on. The free tier renders the editor
// exactly as it did before the AI work started; only tenants with
// AI in their license see the third pane.
//
// Resolution order (matches how identity bootstraps in index.html):
//   1. ?ai=on / ?ai=off URL param  (dev override)
//   2. window.aiEnabled            (set by the portal / WP template)
//   3. import.meta.env.VITE_AI_ENABLED  (build-time default)
//
// Any of those resolving to a string in {true, on, 1, yes} flips the
// flag on. The default is OFF so a build deployed without explicit
// opt-in stays free-tier.
export function isAIEnabled() {
    if (typeof window === 'undefined') return false;
    const params = new URLSearchParams(window.location.search);
    const fromQuery = params.get('ai');
    if (fromQuery !== null) return isTruthy(fromQuery);
    if (window.aiEnabled !== undefined) return isTruthy(String(window.aiEnabled));
    return isTruthy(import.meta.env?.VITE_AI_ENABLED);
}

function isTruthy(v) {
    if (v == null) return false;
    return /^(true|on|1|yes)$/i.test(String(v).trim());
}
